<template>
</template>

<script>
    // import Vue from 'vue'
    import {VueReCaptcha} from 'vue-recaptcha-v3';

    const field = 'RECAPTCHA-TOKEN';
    const delay = 20000;

    export default {
        props: {
            id: String,
            selector: String
        },
        mounted() {
            Vue.use(VueReCaptcha, {siteKey: this.id});
        },
        methods: {
            async AgpmRecaptcha() {
                let $selector = $(this.selector);
                await this.$recaptchaLoaded();
                
                const token = await this.$recaptcha('homepage');
                //input
                $selector.val(token);
                //cookie
                this.$cookies.set(field, token);
                //meta
                $('meta[name="' + field + '"]').attr("content", token);
                //header
                window.axios.defaults.headers.common['X-' + field] = token;
                $.ajaxSetup({
                    headers: {
                        ['X-' + field]: token
                    }
                });
            },
        }
    }
    ;
</script>
